import React, { useEffect, useRef } from "react";
import Role from "../../../component/System/Role";
import { generatePath, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import { connect } from "react-redux";
import { loadingShow } from '../../../services/PostAPI';
import { fetchRoles, initializeRoleInfoScreen, saveRoleTableState, deleteRole, setDeleteConfirmationPopupVisibility } from "../../../redux/actions/System/Role";
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';

const RoleScreen = (props) => {
  const {
    fetchRoles,
    initializeRoleInfoScreen,
    screenPermissions,
    showPageLevelLoader,
    roleListView,
    paginationInfo,
    isLoading,
    savedTableState,
    saveRoleTableState,
    deleteRole,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isDeleteRoleSuccess,
    isDeleteRoleError,
  } = props;

  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initializeRoleInfoScreen();

    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRoles(savedParams);
    } else {
      fetchRoles({ sortField: 'id' });
    }
  }, []);

  const navigate = useNavigate();

  const handleCreateRole = () => {
    navigate(APP_URLS.SYSTEM_ROLES.CREATE);
  };

  const handleEditRole = (id) => {
    const path = generatePath(APP_URLS.SYSTEM_ROLES.EDIT, {
      id,
    });
    navigate(path);
  };

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchRoles(newProps);
  };

  const handleDeleteRole = (payload) => {
    deleteRole(payload);
  };

  const handleTableStateChange = (rawParams) => {
    saveRoleTableState(rawParams);
  };

  const roleProps = {
    handleCreateRole,
    handleEditRole,
    screenPermissions,
    tableData: roleListView,
    paginationInfo,
    fetchRolesInfos: loadLazyData,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    isLoading,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    handleDeleteRole,
    isDeleteRoleSuccess,
    isDeleteRoleError,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      <Role {...roleProps} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeRoleInfoScreen: () => dispatch(initializeRoleInfoScreen()),
    fetchRoles: (payload) => dispatch(fetchRoles(payload)),
    saveRoleTableState: (payload) => dispatch(saveRoleTableState(payload)),
    deleteRole: (id) => dispatch(deleteRole(id)),
    setDeleteConfirmationPopupVisibility: (payload) => dispatch(setDeleteConfirmationPopupVisibility(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    roleListView: selectRolesList(state.roleReducer),
    showPageLevelLoader: selectIsLoadingPage(state.roleReducer),
    paginationInfo: selectPaginationInfo(state.roleReducer),
    isPageLevelError: selectIsPageLevelError(state.roleReducer),
    isLoading: selectIsLoading(state.roleReducer),
    savedTableState: selectSavedTableState(state.roleReducer),
    shouldOpenDeleteConfirmationPopup: state.roleReducer?.shouldOpenDeleteConfirmationPopup,
    isDeleteRoleSuccess: state.roleReducer?.isDeleteRoleSuccess,
    isDeleteRoleError: state.roleReducer?.isDeleteRoleError,
  };
};

const selectRolesList = (roleReducer) => roleReducer?.roleListView;
const selectIsLoadingPage = (roleReducer) => roleReducer?.isLoadingPage;
const selectPaginationInfo = (roleReducer) => roleReducer?.paginationInfo;
const selectIsPageLevelError = (roleReducer) => roleReducer?.isPageLevelError;
const selectIsLoading = (roleReducer) => roleReducer?.isLoading;
const selectSavedTableState = (roleReducer) => roleReducer?.savedTableState;

export default connect(mapStateToProps, mapDispatchToProps)(RoleScreen);
